var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFelineFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2595_3703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H27.6484V27.6484H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2595_3703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.07855 1.08191V18.0742C1.07855 22.7665 4.88237 26.5703 9.57467 26.5703H18.0708C22.7631 26.5703 26.567 22.7665 26.567 18.0742V1.08191L20.1949 5.33H18.0708H7.45065L1.07855 1.08191Z",
    stroke: "#FF669B",
    strokeWidth: 2.16003,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57422 7.45508V5.33106",
    stroke: "#FF669B",
    strokeWidth: 2.16003,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0699 7.45508V5.33106",
    stroke: "#FF669B",
    strokeWidth: 2.16003,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8244 9.57227V5.32423",
    stroke: "#FF669B",
    strokeWidth: 2.16003,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8223 15.9492C13.8223 18.2953 11.9203 20.1973 9.57422 20.1973",
    stroke: "#FF669B",
    strokeWidth: 2.16003,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0725 20.1973C15.7264 20.1973 13.8244 18.2953 13.8244 15.9492",
    stroke: "#FF669B",
    strokeWidth: 2.16003,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9476 15.9473H11.6995",
    stroke: "#FF669B",
    strokeWidth: 2.16003,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4426 13.8301H26.5666",
    stroke: "#FF669B",
    strokeWidth: 2.16003,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4426 18.0762H26.5666",
    stroke: "#FF669B",
    strokeWidth: 2.16003,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07855 13.8301H3.20257",
    stroke: "#FF669B",
    strokeWidth: 2.16003,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07855 18.0762H3.20257",
    stroke: "#FF669B",
    strokeWidth: 2.16003,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1783 13.1405C11.6257 13.1405 11.9883 12.7779 11.9883 12.3305C11.9883 11.8832 11.6257 11.5205 11.1783 11.5205C10.731 11.5205 10.3683 11.8832 10.3683 12.3305C10.3683 12.7779 10.731 13.1405 11.1783 13.1405Z",
    fill: "#FF669B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9388 13.1347C17.3862 13.1347 17.7488 12.772 17.7488 12.3247C17.7488 11.8773 17.3862 11.5146 16.9388 11.5146C16.4915 11.5146 16.1288 11.8773 16.1288 12.3247C16.1288 12.772 16.4915 13.1347 16.9388 13.1347Z",
    fill: "#FF669B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFelineFilter);
export default __webpack_public_path__ + "static/media/FelineFilter.a41ba54f4ac10c74432afeedcccfa311.svg";
export { ForwardRef as ReactComponent };